import prod from './prod';
import stag from './stag';
import dev from './dev';
import qa from './qa';
import poc from './poc';
import dr from './dr';
import store from '../redux/store';
import { getIsLiveMerchant } from '../lib/localStorage';



const config: any = (env?) => {
  const allconfig = {
    prod,
    stag,
    dev,
    qa,
    poc,
    dr,
  };
  let BUILD_ENV = process.env.REACT_APP_BUILD_ENV;

  if (env && allconfig[env]) {
    return allconfig[env];
  }
  

const isLiveMerchant = (): boolean =>
  Boolean(store?.getState()?.loginReducer?.loginState?.isLiveMerchant);

const isUserLoggedIn = (): boolean =>
  Boolean(store?.getState()?.loginReducer?.loginState?.token);



const TestMerchant = isUserLoggedIn() ? !isLiveMerchant() : null;

  
  // TEST: UAT | LIVE: QA

  // on QA bundle: swap to stag when live
  if (BUILD_ENV === 'qa') {
    if(TestMerchant === null) {
      BUILD_ENV = 'qa';
    }else{
     BUILD_ENV = TestMerchant === true ? 'qa' : 'qa';
    }
  }

 else if (BUILD_ENV === 'stag') {
    if (TestMerchant === null) {
      // Not logged in → stay in stag
      BUILD_ENV = 'stag';
    } else {
      BUILD_ENV = TestMerchant ? 'qa' : 'stag';
    }
  }
  // on PROD bundle: swap to prod when live
  else if (BUILD_ENV === 'prod') {
    BUILD_ENV = TestMerchant === true ? 'stag' : 'prod';
  }

  if (BUILD_ENV === 'dr' && TestMerchant) {
    BUILD_ENV = 'stag';
  }

  return allconfig[BUILD_ENV || 'dev']
    ? allconfig[BUILD_ENV || 'dev']
    : allconfig['dev'];
};

export default config;
